// extracted by mini-css-extract-plugin
export default {"subscription":"B6RTZ","content":"iXQ2F","title":"oZ0g6","text":"B_Ba9","share":"kIYDl","shareText":"HOnPN","wrapper":"PrBrH"};